import axios from "axios";

import _ from 'lodash';
const to = (promise)=>(promise.then(data => [null, data]).catch(err => [err]));

export const PEITFile=async({id,obj,lng,onUploadProgress})=>{      
    const url = "https://nu2qt9of3k.execute-api.us-east-1.amazonaws.com/dev/upload"
    const params={id}
    const [err,response]=await to(axios.get(url, {params}));
    if(err) throw err    
    
    const payload = {...obj,lng}
    const file= new Blob([JSON.stringify(payload)], {"name":"name",type: 'application/json'}); 
    const [err2,response2]=await to(_upload({...response.data,file,onUploadProgress}));
    if(err2) throw err2
    return
}

export const PEITTableFile=async({id,tableId,file,onUploadProgress})=>{      
    const url = "https://nu2qt9of3k.execute-api.us-east-1.amazonaws.com/dev/uploadTable"
    const params={id,tableId}
    const [err,response]=await to(axios.get(url, {params}));
    if(err) throw err            
    const [err2,response2]=await to(_upload({...response.data,file,onUploadProgress}));
    if(err2) throw err2
    return
}

export const PEITGET=async({id,onUploadProgress})=>{      
    const url = "https://nu2qt9of3k.execute-api.us-east-1.amazonaws.com/dev"
    const params = {id}
    const [err,response]=await to(axios.get(url, {params}));
    if(err) throw err    
    // console.log(response)
    return response.data
}
export const PEITDOWNLOAD=async(url)=>{
    // console.log("url",url)
    const [err,response]=await to(axios.get(url,{ responseType: 'arraybuffer', headers: {     'Cache-Control': 'no-cache'} }));
    if(err) throw err;      
    // console.log(response)
    return response.data
}
const DATA_KEY_ZONE="PEITZONE";
export const PEITZONE=async()=>{      
    // const _zones=localStorage.getItem(DATA_KEY_ZONE)
    // if(_zones)return JSON.parse(_zones)
    
    const url="https://peit-oiep.s3.amazonaws.com/public/tables/peit_zones.json"
    const [err,response]=await to(axios.get(url));
    if(err) throw err;      
    // localStorage.setItem(DATA_KEY_ZONE, JSON.stringify(response.data));    
    
    return response.data
}

const _upload=async({item,key,url,fields,file,onUploadProgress=(progressEvent)=>null})=>{  
  const payload = new FormData();
  Object.entries(fields).forEach(([ key, val ]) => {
    payload.append(key, val);
  });
  payload.append("file", file);
  payload.append("Content-Type", file.type||"application/octet-stream");
  
  const headers= {'Content-Type': 'multipart/form-data'};
  console.log(file.type)
  const [err,response]=await to(axios.post(url, payload,{headers,onUploadProgress}));  
  if(err)throw err;
  return {...item,id:key}  
};